export default "__VITE_ASSET__BRzLm1Lf__"